import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

const requestInfo = () => ({
  type: types.REQUEST_INFO
})

const receiveInfo = data => ({
  type: types.RECEIVE_INFO,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorInfo = () => ({
  type: types.ERROR_INFO
})

export const fetchInfo = () => dispatch => {
  dispatch(requestInfo());

  return fetch(`/api/info`)
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveInfo(json)))
    .catch(e => dispatch(errorInfo(e)))
}



// WEBPACK FOOTER //
// ./src/components/info/actions.js